import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AngularConfiguration } from '../../model/v2/angular-configuration';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class AngularConfigurationService {

  constructor(private baseService: BaseService) { }

  getConfiguration(): Observable<AngularConfiguration> {
    return this.baseService.getLocal<AngularConfiguration>(`/api/GetAngularConfiguration`);
  }
}
